import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface SpinnerStyle {
  size?: number;
  thickness?: number;
  spinnerClass?: string;
  messageClass?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private isLoading = new BehaviorSubject<boolean>(false);
  private message = new BehaviorSubject<string>('Loading...');
  private style = new BehaviorSubject<SpinnerStyle>({});

  // Public observables
  isLoading$ = this.isLoading.asObservable();
  message$ = this.message.asObservable();
  style$ = this.style.asObservable();

  show(style?: SpinnerStyle, msg?: string) {
    if (style) this.style.next(style);
    if (msg) this.message.next(msg);
    this.isLoading.next(true);
  }

  hide() {
    this.isLoading.next(false);
  }
}
